import React from 'react';

import {FIELD_MODULE} from 'utils/constants/custom_field';

import TypeDefinition from './components/type_definition';

const ProjectProperty = () => {
    return (
        <TypeDefinition module={FIELD_MODULE.Projects}/>
    );
};

export default ProjectProperty;
